import React from "react";
import {
    List, ListItem, ListItemText, Grid, Divider, Snackbar, Typography
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import Avatar from "@mui/material/Avatar";
import {BASE_URL_MESSENGER_API, URL_GROUP_AVATAR} from "../../Const";
import GroupIcon from "../../assets/icons/group.svg";
import {Link} from "react-router-dom";
import {GroupRepository} from "../../Repository/messenger/GroupRepository";
import {ImageLoader} from "./ImageLoader";
import {BottomMenu} from "../HookUtils";
import moment from "moment-jalaali";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export class GroupListComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            channelList: [],
            openSnackbar: false,
            message: "",
            snackbarType: "success"
        };
    }

    componentDidMount() {
        const cached = GroupRepository.getAll("group");
        if (cached?.length) {
            this.setState({ channelList: cached });
        }
        this.fetchChannelList();
    }


    fetchChannelList = () => {
        fetch(BASE_URL_MESSENGER_API + 'groups?mode=group', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_messenger_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {
                if (results.code === "200") {
                    GroupRepository.saveGroups(results.data);
                    this.setState({channelList: results.data});
                }
            })
            .catch(() => console.log("Error loading channels"));
    };

    render() {
        const handleCloseSnackbar = () => {
            this.setState({openSnackbar: false});
        };

        return (
            <div style={{ direction: 'rtl', padding: 8 }}>
                <List>
                    {this.state.channelList.map((item, index) => (
                        <React.Fragment key={item.id}>
                            <ListItem
                                button
                                component={Link}
                                to={`/messenger/chat?chat_id=${item.chat_id}`}
                            >
                                <Grid container spacing={1} alignItems="center">
                                    <Grid item>
                                        {item.avatar ? (
                                            <ImageLoader
                                                url={URL_GROUP_AVATAR + item.avatar}
                                                width={56}
                                                height={56}
                                                thumbnail=""
                                                style={{ borderRadius: '50%' }}
                                            />
                                        ) : (
                                            <Avatar src={GroupIcon} style={{ width: 56, height: 56 }} />
                                        )}
                                    </Grid>

                                    <Grid item xs>
                                        <Typography
                                            variant="subtitle1"
                                            style={{ fontWeight: 'bold', textAlign: 'right' }}
                                        >
                                            {item.title || "نامشخص"}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            style={{ color: '#607D8B', textAlign: 'right' }}
                                        >
                                            {item.description}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            style={{ color: '#90A4AE', textAlign: 'right' }}
                                        >
                                            {item.member_count} عضو - {moment.unix(item.created_at).format("jYYYY/jMM/jDD")}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </ListItem>

                            {index < this.state.channelList.length - 1 && (
                                <Divider style={{ margin: '4px 0' }} />
                            )}
                        </React.Fragment>
                    ))}
                </List>


                <Snackbar
                    open={this.state.openSnackbar}
                    autoHideDuration={6000}
                    onClose={handleCloseSnackbar}
                >
                    <Alert onClose={handleCloseSnackbar} severity={this.state.snackbarType}>
                        {this.state.message}
                    </Alert>
                </Snackbar>
            </div>
        );
    }
}
